import { render, staticRenderFns } from "./faq-item-height-transition.vue?vue&type=template&id=41dd10fd&scoped=true&"
import script from "./faq-item-height-transition.vue?vue&type=script&lang=js&"
export * from "./faq-item-height-transition.vue?vue&type=script&lang=js&"
import style0 from "./faq-item-height-transition.vue?vue&type=style&index=0&id=41dd10fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd10fd",
  null
  
)

export default component.exports